import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Typography,
  Link,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { FONT_SIZE } from "../../../../constants/fontSizes";
import { TEXT_COLOR_PRIMARY } from "../../../../constants/colors";
import { useIsDesktop } from "../../hooks/useIsDesktop";

const HOVER_BG = "rgba(255,255,255,0.08)";

export default function Header({
  isGuest,
  onOpenMenu,
  rightSlot = null,
  homeHref,
}) {
  const isDesktop = useIsDesktop();
  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        bgcolor: "#fff",
        color: "text.primary",
        borderBottom: "1px solid",
        borderColor: "divider",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar
        disableGutters
        sx={{ position: "relative", pl: isDesktop ? 2 : 0, minHeight: 0 }}
      >
        {/* SPメニュー */}
        {!isGuest && !isDesktop && (
          <IconButton
            onClick={() => onOpenMenu?.()}
            edge="start"
            aria-label="メニューを開く"
            sx={{
              p: 0,
              m: 0,
              width: { xs: 48, sm: 60 },
              height: { xs: 48, sm: 60 },
              borderRadius: 0,
              bgcolor: "#6C73DD",
              color: "#fff",
              zIndex: 2,
              position: "relative",
              overflow: "hidden",
              "&:hover": { bgcolor: "#6C73DD" },
              "&:hover::after": {
                content: '""',
                position: "absolute",
                inset: 0,
                backgroundColor: HOVER_BG,
              },
            }}
          >
            <MenuIcon />
          </IconButton>
        )}

        {/* ロゴ */}
        <Link
          href={homeHref}
          underline="none"
          sx={{
            color: TEXT_COLOR_PRIMARY,
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            gap: 1.2,
            cursor: "pointer",
            minWidth: 0,
            p: isGuest ? 1 : 0,

            // ゲスト時は常に左寄せ
            // ログイン時は Desktop以外で中央固定
            position: isGuest ? "static" : isDesktop ? "static" : "absolute",

            left: !isGuest && !isDesktop ? "50%" : "auto",
            top: !isGuest && !isDesktop ? "50%" : "auto",
            transform:
              !isGuest && !isDesktop ? "translate(-50%, -50%)" : "none",
          }}
        >
          <Box
            component="img"
            src="/images/skilllog.webp"
            alt="SkillLog"
            sx={{ height: 28 }}
          />
          <Typography
            sx={{
              fontWeight: 900,
              fontSize: { xs: FONT_SIZE.SM, sm: FONT_SIZE.LG },
              whiteSpace: "nowrap",
            }}
          >
            スキルログ
          </Typography>
          <Typography
            sx={{
              display: { xs: "none", sm: "block" },
              fontSize: FONT_SIZE.XS,
              color: TEXT_COLOR_PRIMARY,
              whiteSpace: "nowrap",
            }}
          >
            スキルを整理、魅力を最大化
          </Typography>
        </Link>

        <Box sx={{ flexGrow: 1 }} />

        {/* 右側（差し替え） */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {rightSlot}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
